import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import React from "react";

export const NotificationSend = (
  type: "info" | "success" | "warning" | "error",
  message: string | number = ""
): void => {
  switch (type) {
    case "info":
      NotificationManager.info(message);
      break;
    case "success":
      NotificationManager.success(message, "Успех!", 1000);
      break;
    case "warning":
      NotificationManager.warning(
        "Warning message",
        "Close after 3000ms",
        3000
      );
      break;
    case "error":
      NotificationManager.error(message, "Возникла ошибка!", 5000);
      break;
  }
};

const Notification = (): JSX.Element => {
  return <NotificationContainer />;
};
export default Notification;
